import React, { useEffect, useRef, useState } from 'react';
import { getPublicFAQ, searchPublicFAQ } from '../services/faq';
import Accordion from '../components/ui/accordion';

const LANGS = [
  { code: 'fr', name: 'Français' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'ar', name: 'العربية' },
  { code: 'it', name: 'Italiano' },
  { code: 'de', name: 'Deutsch' },
];

const FAQ = () => {
  const [lang, setLang] = useState('fr');
  const [data, setData] = useState({ categories: [], language: 'fr' });
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const timer = useRef(null);

  const loadFAQ = async (l) => {
    setLoading(true);
    try {
      const res = await getPublicFAQ(l);
      setData(res);
    } catch (e) {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadFAQ(lang); setResults([]); setQuery(''); }, [lang]);

  const isRTL = lang === 'ar';

  const onSearch = (val) => {
    setQuery(val);
    if (timer.current) clearTimeout(timer.current);
    if (!val.trim()) { setResults([]); return; }
    timer.current = setTimeout(async () => {
      const res = await searchPublicFAQ(val, lang, 20, 0);
      setResults(res.results || []);
    }, 350);
  };

  return (
    <div className={`max-w-4xl mx-auto p-6 ${isRTL ? 'text-right' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-semibold">FAQ</h1>
        <div className="flex items-center gap-2">
          <input
            className="px-3 py-2 bg-background border rounded"
            placeholder={isRTL ? 'بحث...' : 'Rechercher…'}
            value={query}
            onChange={(e) => onSearch(e.target.value)}
            style={{ direction: isRTL ? 'rtl' : 'ltr' }}
          />
          <select value={lang} onChange={(e) => setLang(e.target.value)} className="px-3 py-2 bg-background border rounded">
            {LANGS.map(l => (<option key={l.code} value={l.code}>{l.name}</option>))}
          </select>
        </div>
      </div>

      {results.length > 0 && (
        <div className="mb-6 border rounded-lg p-4 bg-card">
          <div className="font-medium mb-2">{isRTL ? 'نتائج البحث' : 'Résultats de la recherche'}</div>
          <ul className="list-disc pl-5 space-y-1">
            {results.map(r => (
              <li key={r.id}>
                <div className="font-medium">{r.question}</div>
                <div className="text-sm text-muted-foreground">{r.answer}</div>
              </li>
            ))}
          </ul>
        </div>
      )}

      {loading ? (
        <div className="text-muted-foreground">{isRTL ? 'جار التحميل…' : 'Chargement…'}</div>
      ) : (
        <div className="space-y-4">
          {data.categories.map((cat) => (
            <div key={cat.category_id} className="border rounded-lg p-4 bg-card">
              <h2 className="text-xl font-medium mb-3">{cat.category_name}</h2>
              <div className="space-y-2">
                {cat.items.map((it) => (
                  <Accordion type="single" collapsible key={it.id} defaultValue={null}>
                    <Accordion.Item value={`item-${it.id}`}>
                      <Accordion.Trigger className="text-left w-full">{it.question}</Accordion.Trigger>
                      <Accordion.Content>{it.answer}</Accordion.Content>
                    </Accordion.Item>
                  </Accordion>
                ))}
              </div>
            </div>
          ))}
          {data.categories.length === 0 && (
            <div className="text-muted-foreground">{isRTL ? 'لا توجد أسئلة حالياً.' : 'Aucune question pour l’instant.'}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default FAQ;